/* store.js */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: 0,
    blog_link: 'https://www.notion.so/Tomato-Crew-Blogs-f2d9f53181644606ae8e9d295e782d70',
    job_link: 'https://tomatocrew.workfit.info/',
    event_01: 'https://www.notion.so/EMBEDDED-66256fa92e1948fb94e37380e92d21a2',
    event_02: 'https://www.notion.so/7ad78dd13b0b4f6cb1b7873c4fcf3e67',
    termOfUse_link: 'https://pgm.tomatocrewapp.com/pgm/term-detail/6',
    privacyPolicy_link: 'https://pgm.tomatocrewapp.com/pgm/term-detail/7'
  },
  mutations: {
    increment (state) {
      state.count++
    },
    decrement (state) {
      state.count--
    }
  }
})


// WEBPACK FOOTER //
// ./src/store.js